<div class="route-map-dialog">
  <div class="dialog-content">
    <!-- Full-width Google Maps -->
    <div class="map-container">
      <hmt-map [mapTheme]="'silver'" #mapComponent></hmt-map>
      
      <!-- Floating location list panel with route details (left side, centered) -->
      <div class="floating-panel locations-panel">
        <div class="locations-list">
          <div class="location-item" *ngFor="let stop of stopList; let i = index">
            <div class="location-marker">
              <img src="assets/images/location-list-item.png" alt="Location" class="marker-icon" />
              <div class="connector-line" *ngIf="i < stopList.length - 1"></div>
            </div>
            <div class="location-details">
              <div class="location-name">{{ stop.name }}</div>
              <div class="location-type">{{ stop.type }}</div>
            </div>
          </div>
        </div>

        <!-- Route details at bottom of panel -->
        <div class="summary">
          <div class="summary-item">
            <span class="summary-label">Total Locations</span>
            <span class="summary-value">{{ stopList.length }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Total Distance</span>
            <span class="summary-value">{{ totalDistance }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Transit Time</span>
            <span class="summary-value">{{ totalTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

